export const APP_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

export const moneyFields = ["amount", "currencyCode"];

export const selectedOptionFields = ["name", "value"];

export const customerAccessTokenFields = ["accessToken", "expiresAt"];

export const customerUserErrorFields = ["code", "field", "message"];

export const userErrorFields = ["field", "message"];

export const optionFields = ["id", "name", "values"];

export const pageFields = ["hasNextPage", "hasPreviousPage", "endCursor", "startCursor"];

export const metafieldFields = ["key", "type", "value", "namespace"];

export const imageFields = ["altText", "height", "id", "url", "width"];

export const menuFields = ["id", "title", "url"];

export const seoFields = ["description", "title"];

export const filterFields = ["id", "label", "type", { values: ["id", "label", "input", "count"] }];

export const shopFields = ["body, handle, id, title, url"];

export const mailingAddressFields = [
  "address1",
  "address2",
  "city",
  "company",
  "country",
  "countryCodeV2",
  "firstName",
  "lastName",
  "phone",
  "province",
  "provinceCode",
  "zip",
  "id",
];

export const customerFields = ["id", "firstName", "lastName", "acceptsMarketing", "email", "phone", "tags"];

export const customAttributesFields = ["key", "value"];

export const orderFields = [
  "id",
  "name",
  "orderNumber",
  "processedAt",
  "canceledAt",
  "phone",
  "financialStatus",
  "fulfillmentStatus",
  "cancelReason",
  { currentTotalDuties: moneyFields },
  { currentTotalPrice: moneyFields },
  { currentTotalTax: moneyFields },
  { totalPrice: moneyFields },
  { currentSubtotalPrice: moneyFields },
  { subtotalPrice: moneyFields },
  { totalShippingPrice: moneyFields },
  { shippingAddress: mailingAddressFields },
  { billingAddress: mailingAddressFields },
  { totalRefunded: moneyFields },
  { customAttributes: customAttributesFields },
  { shippingDiscountAllocations: [{ allocatedAmount: moneyFields }] },
];

export const orderAmountFields = [
  "name",
  "processedAt",
  "canceledAt",
  "financialStatus",
  "fulfillmentStatus",
  { totalPrice: moneyFields },
  { subtotalPrice: moneyFields },
  { totalRefunded: moneyFields },
];

export const fulfillmentFields = [{ trackingInfo: ["number", "url"] }];

export const productPriceRangeFields = [{ maxVariantPrice: moneyFields }, { minVariantPrice: moneyFields }];

export const productOptionFields = ["id", "name", "values"];

export const productFields = [
  "availableForSale",
  { compareAtPriceRange: productPriceRangeFields },
  "createdAt",
  "description",
  "descriptionHtml",
  { featuredImage: imageFields },
  "handle",
  "id",
  { options: productOptionFields },
  { priceRange: productPriceRangeFields },
  "productType",
  "publishedAt",
  "tags",
  "title",
  "totalInventory",
  "vendor",
];

export const productVariantFields = [
  "availableForSale",
  "barcode",
  { compareAtPrice: moneyFields },
  "currentlyNotInStock",
  "id",
  { image: imageFields },
  { price: moneyFields },
  { product: productFields },
  "quantityAvailable",
  { selectedOptions: selectedOptionFields },
  "sku",
  "weight",
  "weightUnit",
  "title",
];

export const variantFields = [
  "availableForSale",
  "barcode",
  { compareAtPrice: moneyFields },
  "currentlyNotInStock",
  "id",
  { image: imageFields },
  { price: moneyFields },
  "quantityAvailable",
  { selectedOptions: selectedOptionFields },
  "sku",
  "weight",
  "weightUnit",
  "title",
];

export const articlesFields = [
  { authorV2: ["name"] },
  "contentHtml",
  "content",
  "excerptHtml",
  "handle",
  "id",
  { image: imageFields },
  "publishedAt",
  "title",
  "tags",
  { seo: seoFields },
  { blog: ["handle"] },
];
